import { notEmpty } from "shared/lib/utils";

import { StaticSourceUrl } from "./enums";

export const isYoutubeVideo = (
  attributes:
    | undefined
    | {
        "data-youtube-id"?: string;
      },
) => notEmpty(attributes?.["data-youtube-id"]);

export const isDataWrapper = (source: string) => source.includes(StaticSourceUrl.DataWrapper);

export const isSCMPMultimedia = (source: string) => source.includes(StaticSourceUrl.SCMPMultimedia);

export const checkSchemaNodeHasYoutubeVideo = (node: SchemaNode) => {
  if (!node) return false;
  const checkIsYoutubeVideo = (node: SchemaNode): boolean => {
    if (node?.children && node?.children.length > 0)
      return node.children?.some(n => checkIsYoutubeVideo(n));
    return isYoutubeVideo(node.attribs);
  };
  return checkIsYoutubeVideo(node);
};

export const getDimensionWithUnit = (
  dimension?: number | string,
  defaultValue: string = "auto",
) => {
  if (!notEmpty(dimension)) return defaultValue;
  if (typeof dimension === "string") {
    if (dimension.endsWith("%")) return dimension;
    if (dimension.endsWith("px")) return dimension;
    dimension = Number.parseFloat(dimension);
  }
  return `${dimension}px`;
};

export const getYoutubeIdFromUrl = (source: string) => {
  /* cspell:disable-next-line */
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = source.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};
